import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["banner", "messageText"];
  static values = {
    keepExistingUpdateAll: String,
    takeImportKeepExistingValues: String,
    onlyImported: String,
    onlyNew: String,
  };

  connect() {
    this.updateBanner();
  }

  checkboxChanged() {
    this.updateBanner();
  }

  updateBanner() {
    if (!this.hasBannerTarget || !this.hasMessageTextTarget) {
      return;
    }

    // Find checkboxes - Rails generates predictable names
    const updateCheckbox = this.element.querySelector(
      'input[type="checkbox"][name*="update_existing"]'
    );
    const deleteCheckbox = this.element.querySelector(
      'input[type="checkbox"][name*="delete_unlisted"]'
    );

    if (!updateCheckbox || !deleteCheckbox) {
      this.bannerTarget.style.display = "none";
      return;
    }

    const updateChecked = updateCheckbox.checked;
    const deleteChecked = deleteCheckbox.checked;

    let messageKey;
    if (updateChecked && deleteChecked) {
      messageKey = "onlyImported";
    } else if (updateChecked && !deleteChecked) {
      messageKey = "keepExistingUpdateAll";
    } else if (!updateChecked && deleteChecked) {
      messageKey = "takeImportKeepExistingValues";
    } else {
      messageKey = "onlyNew";
    }

    const message = this.getMessageForKey(messageKey);
    if (message) {
      this.messageTextTarget.textContent = message;
      this.bannerTarget.style.display = "block";
    } else {
      this.bannerTarget.style.display = "none";
    }
  }

  getMessageForKey(messageKey) {
    const messages = {
      keepExistingUpdateAll: this.keepExistingUpdateAllValue,
      takeImportKeepExistingValues: this.takeImportKeepExistingValuesValue,
      onlyImported: this.onlyImportedValue,
      onlyNew: this.onlyNewValue,
    };

    return messages[messageKey] || "";
  }
}
